import { Pipe, PipeTransform } from '@angular/core';
import { Form, ValueList, ValueListItem } from '../services/generated/models';
import { FormService } from '../services/form.service';

@Pipe({
    name: 'getValueListItemText',
    pure: false
})
export class GetValueListItemText implements PipeTransform {

    constructor(private formService: FormService) {}

    transform(valuelistItem: ValueListItem): any {
        const that = this;
        let result = valuelistItem.Value;
        if (that.formService.currentForm != null) {
            const t = that.formService.currentForm.Texts.find(x => x.ValueListId === valuelistItem.ValueListId && x.ValueListItemId === valuelistItem.Id);
            if (t) {
                result = t.CustomValue;
            }
        }
        return result;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/pipes/getValueListItemText.ts